import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { API_URL } from "@/lib/utils";

const GoogleRedirectPage = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Extract all query parameters from the URL
    const invitationToken = searchParams.get("invitationToken");
    const redirect = searchParams.get("redirect");

    // Build query string for backend URL
    const params = new URLSearchParams();
    if (invitationToken) {
      params.append("invitationToken", invitationToken);
    }
    if (redirect) {
      params.append("redirect", redirect);
    }

    // Build backend Google OAuth URL
    const queryString = params.toString();
    const backendUrl = `${API_URL}/auth/google${queryString ? `?${queryString}` : ""}`;

    // Redirect to backend Google OAuth endpoint
    window.location.href = backendUrl;
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to Google authentication...</p>
      </div>
    </div>
  );
};

export default GoogleRedirectPage;

